import { connect } from 'react-redux';
import TasksView from '../../../components/tasks/view/TasksView';
import {
  tasksFilterList,
  tasksFilterSearchList,
  tasksList,
  progressTasksType,
  progressTasksTypeBaseline,
  loadingProgress,
  loadingTaskList,
  progressLoadedStore,
  loadingMoreTask,
  currentTaskType,
  resourcesTasksType,
  supplierIds,
  supplierSelected,
  currentStore,
  aislesByTaskList,
  aisleClientNames,
  loadingAisles,
  currentStoreName,
  currentChain,
  filters,
  brandDict,
  tasksStatusList,
  hasOverheadTasks,
} from 'core/selectors';
import { getTaskList, clearTaskList, setCurrentTaskType, loadMoreTasks, loadTaskList, getTasksProgress, setTasksFilter, getTasksStatus, updateTaskStatusLocally } from 'core/slices/tasks';
import { addFilter, resetFilter, setSupplierSelected } from 'core/slices/filter';
import { getAislesByTasks } from 'core/slices/aisles';
import { getResourcesOverhead } from 'core/slices/resources_overhead';
import { getResourcesTaskDetailsFeatures } from 'core/slices/resources_task_details_features';
import { getAllBrands } from 'core/slices/brands';
import { updateTasks } from 'core/slices/tasks_modification';
import { getCategoriesData, getCategoryProgress } from 'core/slices/categories';

export default connect(
  (state) => ({
    tasksFilterList: tasksFilterList(state),
    tasksFilterSearchList: tasksFilterSearchList(state),
    tasksList: tasksList(state),
    progressTasksType: progressTasksType(state),
    progressTasksTypeBaseline: progressTasksTypeBaseline(state),
    taskLoading: loadingTaskList(state),
    loadingProgress: loadingProgress(state),
    progressLoadedStore: progressLoadedStore(state),
    moreTasksLoading: loadingMoreTask(state),
    currentTaskType: currentTaskType(state),
    resourcesTasksType: resourcesTasksType(state),
    filters: filters(state),
    supplierSelected: supplierSelected(state),
    supplierIds: supplierIds(state),
    currentStore: currentStore(state),
    aislesByTaskList: aislesByTaskList(state),
    aisleClientNames: aisleClientNames(state),
    loadingAisles: loadingAisles(state),
    currentStoreName: currentStoreName(state),
    currentChain: currentChain(state),
    brandDict: brandDict(state),
    tasksStatusList: tasksStatusList(state),
    hasOverheadTasks: hasOverheadTasks(state),
  }),
  {
    getTaskList,
    getTasksStatus,
    getAllBrands,
    clearTaskList,
    loadMoreTasks,
    loadTaskList,
    getTasksProgress,
    getAislesByTasks,
    getResourcesOverhead,
    getResourcesTaskDetailsFeatures,
    setCurrentTaskType,
    addFilter,
    resetFilter,
    setSupplierSelected,
    setTasksFilter,
    updateTasks,
    updateTaskStatusLocally,
    getCategoriesData,
    getCategoryProgress,
  },
)(TasksView);
